export const mediaPhone = `@media (max-width: 767px)`;
export const mediaDesktop = `@media (min-width: 768px)`;
export const mediaIPadPro = `@media (width: 1024px) and (height: 1366px)`;
export const mediaIPad = `@media (width: 768px) and (height: 1024px)`;
export const media900 = ` @media (max-width: 900px)`;
export const media410 = ` @media (max-width: 410px) `;
